import { render, staticRenderFns } from "./TableTabs.vue?vue&type=template&id=72a9b096&scoped=true&"
import script from "./TableTabs.vue?vue&type=script&lang=ts&"
export * from "./TableTabs.vue?vue&type=script&lang=ts&"
import style0 from "./TableTabs.vue?vue&type=style&index=0&id=72a9b096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a9b096",
  null
  
)

export default component.exports
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTabs,QTab,QIcon,QTabPanel});
